module.exports = __webpack_public_path__ + "img/huodong_mini2.48edbed7.jpg";